export default __webpack_public_path__ + "static/media/iitklogo.b5d612f4.jpeg";